import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Path } from 'constants/router'
import { useBkbnSearchParams } from 'utils/hooks/useBkbnSearchParams'

/**
 * Returns a callback that navigates to the Propstack embed purchase flow for `objectReferenceId`,
 * preserving the `oneSystem` and `lang` embed params (ISSUE-2018). Shared by the order-now card and
 * the status card's new-order action so both build the target URL identically.
 *
 * The hook does NOT fire analytics; callers log their own source-tagged event before navigating.
 */
export const useNavigateToEmbedPurchaseFlow = (objectReferenceId: string) => {
  const navigate = useNavigate()
  const params = useBkbnSearchParams()

  return useCallback(() => {
    const search = new URLSearchParams()
    search.set('objectReferenceId', objectReferenceId)
    if (params.get('oneSystem')) search.set('oneSystem', params.get('oneSystem')!)
    if (params.get('lang')) search.set('lang', params.get('lang')!)
    navigate(`${Path.EMBED_PURCHASE_FLOW}?${search.toString()}`)
  }, [navigate, params, objectReferenceId])
}
